import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ArrowBackIosNew } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { Typography } from '@mui/material';

const BackNavbar = ({ title, onClick }) => {
  return (
    <motion.div
      className={css(styles.navbar)}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.button
        type='button'
        onClick={onClick}
        className={css(styles.backButton)}
        whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
      >
        <ArrowBackIosNew className={css(styles.icon)} />
      </motion.button>
      <motion.div
        className={css(styles.headerContainer)}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.3 }}
      >
        <Typography className={css(styles.headerText)}>M-TREAT</Typography>
        <span className={css(styles.divider)}>|</span>
        <span className={css(styles.headerText)}>{title}</span>
      </motion.div>
    </motion.div>
  );
};

const styles = StyleSheet.create({
  navbar: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    backgroundColor: 'rgba(248,250,252,0.9)',
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 1000
  },
  backButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    marginRight: '1rem'
  },
  icon: {
    fontSize: '1.5rem',
    color: '#2783F7'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  headerText: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#2783F7'
  },
  divider: {
    margin: '0 0.5rem',
    color: '#2783F7',
    fontWeight: '600',
    fontSize: '1.5rem'
  }
});

export default BackNavbar;
